import Vue from 'vue'
import App from './Home.vue'
// import '../../registerServiceWorker'
import router from './router'
// import store from './store'

// for fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDove, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faArrowCircleRight, faDove)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
//   store,
  render: h => h(App)
}).$mount('#app')
